// Core
import React from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import FlatButton from "material-ui/FlatButton";

// Instruments
import options from './edirtorOptions';

// Styles & assets
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const saveStyle = {
  position: "fixed",
  bottom: "50px",
  right: "50px",
  background: "#6da92e",
  color: "#fff",
  zIndex: 1000000,
};

const stringToEditorObj = str => {
  const blocksFromHtml = htmlToDraft(str);
  const { contentBlocks, entityMap } = blocksFromHtml;
  const contentState = ContentState.createFromBlockArray(
    contentBlocks,
    entityMap
  );
  const editorState = EditorState.createWithContent(contentState);
  return editorState;
};

class TemplatesEditor extends React.PureComponent {
  constructor(props) {
    super();
    const str = props.item;

    const editorState = stringToEditorObj(str);
    this.state = {
      editorState
    };

    options.image.uploadCallback = async (file) => {
        console.log(file)
        const result = await props.onUpload(file, file.name)
        console.log(result)
        return { data: { link: result.url}}
    }
  }

  static getDerivedStateFromProps(props, state) {
    return { ...state, editorState: stringToEditorObj(props.item) };
  }

  onEditorStateChange = editorState => {
    this.setState({
      editorState
    });
  };

  onSave = () => {
      const { editorState } = this.state;
      const { onSave } = this.props;
      const html = draftToHtml(
          convertToRaw(editorState.getCurrentContent())
      ) + '';
      onSave(html)
  }

  render() {
    const { editorState } = this.state;
    console.log(editorState.toJS(), 'editorState')

    return (
      <div className="wrap-templates-editor">
        <Editor
          toolbar={options}
          editorState={editorState}
          onEditorStateChange={this.onEditorStateChange}
          wrapperClassName="wrapper-class"
          editorClassName="editor-class"
          toolbarClassName="toolbar-class"
        />
        <FlatButton
          label="Save"
          onClick={this.onSave}
          backgroundColor="#6da92e"
          hoverColor="#7bd023"
          style={saveStyle}
        />
      </div>
    );
  }
}

export default TemplatesEditor;
